module.exports = __webpack_public_path__ + "img/__icon_HAKÓWKA.d8919dd3.svg";